import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "wrap" }
const _hoisted_2 = {
  key: 0,
  class: "state"
}
const _hoisted_3 = {
  key: 1,
  class: "state"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "doc-title" }
const _hoisted_6 = {
  key: 0,
  class: "badge"
}
const _hoisted_7 = {
  key: 0,
  class: "doc-summary"
}
const _hoisted_8 = { class: "doc-meta" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_menu_button = _resolveComponent("ion-menu-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, { translucent: true }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, { class: "custom-toolbar" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_buttons, { slot: "start" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_menu_button, { color: "light" })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_title, { class: "custom-title" }, {
                default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                  _createTextVNode("Help Center", -1)
                ]))]),
                _: 1
              }),
              _createVNode(_component_ion_buttons, { slot: "end" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_button, {
                    color: "light",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.load(true)))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_icon, {
                        slot: "icon-only",
                        icon: _ctx.refreshOutline
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, {
        fullscreen: true,
        class: "page-bg"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.search) = $event)),
              class: "search",
              type: "search",
              placeholder: "Search guides, e.g. transfer a lead"
            }, null, 512), [
              [_vModelText, _ctx.search]
            ]),
            (_ctx.loading && !_ctx.groups.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, "Loading guides..."))
              : (!_ctx.groups.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.search ? 'No guides match your search.' : 'No guides are available yet.'), 1))
                : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groups, (group) => {
              return (_openBlock(), _createElementBlock("div", {
                key: group.category,
                class: "group"
              }, [
                _createElementVNode("h3", null, _toDisplayString(group.category), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.docs, (doc) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: doc.slug,
                    class: "doc-card",
                    onClick: ($event: any) => (_ctx.$router.push('/help/' + doc.slug))
                  }, [
                    _createElementVNode("div", _hoisted_5, [
                      _createTextVNode(_toDisplayString(doc.title) + " ", 1),
                      (_ctx.isUpdated(doc))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_6, "Updated"))
                        : _createCommentVNode("", true)
                    ]),
                    (doc.summary)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(doc.summary), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_8, "v" + _toDisplayString(doc.version) + " · " + _toDisplayString(doc.updated_at), 1)
                  ], 8, _hoisted_4))
                }), 128))
              ]))
            }), 128))
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}